import React, { useState } from "react";
import { Helmet } from "react-helmet-async";
import {
  Button,
  Card,
  Col,
  Container,
  Row,
  Modal,
  Form,
  Alert,
} from "react-bootstrap";
import { CardElement, useStripe, useElements } from "@stripe/react-stripe-js";
import useAuth from "../../hooks/useAuth";
import axios from "../../utils/axios";
import { PLANS } from "../../constants";

const CARD_OPTIONS = {
  // iconStyle: "solid",
  hidePostalCode: true,
  style: {
    base: {
      iconColor: "#c4f0ff",
      color: "#bfc1c6",
      fontWeight: 400,
      // fontFamily: "Roboto, Open Sans, Segoe UI, sans-serif",
      fontSize: "14px",
      fontSmoothing: "antialiased",
      ":-webkit-autofill": {
        color: "#fce883",
      },
      "::placeholder": {
        color: "#a9acb3",
      },
      webkitAutofill: {
        color: "#a9acb3",
      },
    },
    invalid: {
      iconColor: "#d9534f",
      color: "#d9534f",
    },
    complete: {
      iconColor: "#4BBF73",
      color: "#4BBF73",
    },
  },
};

const Pricing = ({ subscription, refreshData, ...props }: any) => {
  const [isModalOpen, setOpenModal] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [errors, setErrors] = useState<string>("");
  const [name, setName] = useState<string>("");
  const { user } = useAuth();
  const [selectedPlan, setPlan] = useState<any>({
    name: "",
    price: 0,
    features: [],
  });
  const stripe = useStripe();
  const elements = useElements();

  const handleSubmit = async (event: any) => {
    event.preventDefault();
    if (!elements || !stripe) {
      return;
    }
    const card = elements.getElement(CardElement);
    if (!card) {
      return;
    }
    setIsLoading(true);
    const { error, paymentMethod }: any = await stripe.createPaymentMethod({
      type: "card",
      card: card,
      billing_details: { name },
    });

    if (error) {
      setIsLoading(false);
      setErrors(error);
      return;
    }

    const handlePaymentResponse = async (response: any) => {
      debugger;
      if (response.error) {
        // Show error from server on payment form
        console.error(response.error);
      } else if (response.requires_action) {
        // Use Stripe.js to handle the required card action
        const { error: errorAction, paymentIntent }: any =
          await stripe.handleCardAction(response.payment_intent_client_secret);

        if (errorAction) {
          setErrors(errorAction);
          // Show error from Stripe.js in payment form
        } else {
          // The card action has been handled
          // The PaymentIntent can be confirmed again on the server
          const serverResponse: any = await axios.post(
            "/companies/" + user?.companyId + "/subscription/pay",
            {
              payment_intent_id: paymentIntent.id,
              amount: selectedPlan.price,
              stripePriceId: selectedPlan.stripeId,
              payment_method_id: paymentMethod.id,
              name: name,
            }
          );
          console.log(serverResponse);
          handlePaymentResponse(await serverResponse.json());
        }
      } else if (response.data && response.data.error) {
        setErrors(response.data.error);
      } else {
        toggle(true);
      }
    };

    const paymentDetails = {
      payment_method_id: paymentMethod.id,
      amount: selectedPlan.price,
      stripePriceId: selectedPlan.stripeId,
      name: name,
    };
    console.log(paymentDetails);
    const response = await axios.post(
      "/companies/" + user?.companyId + "/subscription/pay",
      paymentDetails
    );
    handlePaymentResponse(response);
  };

  const toggle = (reload: boolean = false) => {
    setOpenModal(!isModalOpen);

    if (reload && refreshData) {
      refreshData(reload);
      // TODO: reload user plan / company
    }
  };

  const deactivate = async () => {
    await axios.delete("/companies/" + user?.companyId + "/subscription");
    refreshData(true);
  };

  return (
    <React.Fragment>
      <Helmet title="Naročnina" />

      <Container fluid className="p-0">
        <Row className="pb-4">
          {PLANS.map((plan, index: number) => {
            return (
              <Col sm="4" className="mb-3 mb-md-0" key={"plan_" + index}>
                <Card className="text-center h-100">
                  <Card.Body className="d-flex flex-column">
                    <div className="mb-1 py-2">
                      <h3 className="mb-3">{plan.name} paket</h3>
                      {plan.price ? (
                        <>
                          <span className="h2">{plan.price}€</span>
                          <span>/mesec</span>
                        </>
                      ) : (
                        <div className="mb-2">po dogovoru</div>
                      )}
                    </div>
                    <hr />
                    <ul className="list-unstyled mt-4">
                      {plan.features.map((feature, index: number) => {
                        return (
                          <li className="mb-2" key={"feature_" + index}>
                            {feature}
                          </li>
                        );
                      })}
                    </ul>
                    <div className="mt-auto">
                      {subscription?.plan.id === plan.stripeId &&
                      !subscription.cancel_at_period_end ? (
                        <Button
                          size="lg"
                          variant="outline-danger"
                          onClick={() => {
                            // toggleDeactivate();
                            deactivate();
                          }}
                        >
                          Deaktiviraj
                        </Button>
                      ) : plan.price ? (
                        <Button
                          size="lg"
                          variant="outline-primary"
                          onClick={() => {
                            setPlan(plan);
                            toggle(true);
                          }}
                        >
                          Aktiviraj
                        </Button>
                      ) : (
                        <a
                          className="btn btn-lg btn-outline-secondary"
                          href="mailto:mail@novioglasi.com?subject=NoviOglasi.com Premuim paket"
                          target="_blank"
                          rel="noreferrer noopener"
                        >
                          Kontakt
                        </a>
                      )}
                    </div>
                  </Card.Body>
                </Card>
              </Col>
            );
          })}
        </Row>
      </Container>

      <Modal show={isModalOpen} size="sm" centered onHide={() => toggle()}>
        <Modal.Header closeButton>
          <Modal.Title>Aktiviraj {selectedPlan.name} paket</Modal.Title>
        </Modal.Header>
        <Modal.Body className="m-3">
          <Card className="text-center mb-1">
            <Card.Body className="d-flex flex-column">
              <div className="mb-2">
                <h5>{selectedPlan.name} paket</h5>
                <span className="display-6">{selectedPlan.price}€</span>
                <span>/mesec</span>
              </div>
              <ul className="list-unstyled">
                {selectedPlan &&
                  selectedPlan.features &&
                  selectedPlan.features.map(
                    (feature: string, index: number) => {
                      return (
                        <li className="mb-1" key={index.toString()}>
                          {feature}
                        </li>
                      );
                    }
                  )}
              </ul>
              <hr />
            </Card.Body>
          </Card>
          <h5 className="mb-3 text-center">Kartica za plačilo</h5>
          <Form onSubmit={handleSubmit}>
            {errors && (
              <Alert variant="danger">
                <div className="alert-message">{errors}</div>
              </Alert>
            )}
            <Form.Group className="mb-3">
              <Form.Control
                type="text"
                name="name"
                id="name"
                value={name}
                placeholder="Ime in priimek"
                // isInvalid={Boolean(
                //   touched.name && errors.name
                // )}
                // onBlur={handleBlur}
                onChange={(event) => {
                  setName(event.target.value);
                }}
              />
              {/*{!!touched.name && (
                <Form.Control.Feedback type="invalid">
                  {errors.name}
                </Form.Control.Feedback>
              )}*/}
            </Form.Group>
            <Form.Group className="mb-3">
              <CardElement
                options={CARD_OPTIONS}
                className="form-control p-2"
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Container>
            <Row className="d-flex">
              <Col className="text-end">
                <Button
                  variant="primary"
                  disabled={isLoading}
                  onClick={handleSubmit}
                >
                  Aktiviraj
                </Button>
              </Col>
            </Row>
          </Container>
        </Modal.Footer>
      </Modal>
    </React.Fragment>
  );
};

export default Pricing;
